module.exports = __webpack_public_path__ + "assets/media/day40.59a57451.mp3";